<template>
	<div class="border-connectProBlue border-2 pl-8 pr-8 pb-8 pt-4 rounded">
		<div class="grid grid-cols-3 gap-x-8 xl:gap-x-8 mt-4">
			<div v-for="document in documents" :key="document.id" class="font-medium">
				<div class="bg-gray-300 rounded flex flex-grow p-4 mb-6 justify-center shadow" style="align-self: start">
					<input
						class="mr-6 w-6 h-6 cursor-pointer"
						:disabled="document.disabled"
						type="checkbox"
						style="accent-color: #0068B4;"
						:checked="document.isChecked"
						v-model="document.isChecked"
						@change="checkValidity(document)"
						v-bind="$attrs"
					/>
					<div class="w-full flex">
						<span class="font-semibold" :style="{ color: document.disabled ? 'grey' : '#2c3e50' }">{{ document.label }}</span>
					</div>
					<div class="ma-2" v-if="checkShowTooltip(document)">
						<div
							class="flex rounded-full h-6 w-6 justify-center cursor-pointer tooltip"
							style="background-color: lightgrey; align-items: center; min-width: 15px"
						>
							<font-awesome-icon :icon="['fas', 'info']" class="flex justify-center text-red-300" style="align-content: center" />
							<div class="tooltiptext">
								{{ getTooltipString(document) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex justify-end">
			<BaseButton class="btn-blue" :disabled="evaluateDisabled" @click="createDocuments">{{ $t('generate_selected_documents') }} </BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { VehicleApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import RentalCarsRepository from '@/api/repositories/RentalCarsRepository';

export default {
	name: 'ProcessDocumentCreateTab',
	components: { BaseButton },
	props: {
		process: null,
	},
	data() {
		return {
			documents: [
				{ id: 'repairContract', label: 'Reparatur-Auftrag', isChecked: false, disabled: false },
				{ id: 'nebenleistungen', label: 'Nebenleistungen', isChecked: false, disabled: false },
				{ id: 'lawyerAuthority', label: 'Rechtsanwalt-Vollmacht', isChecked: false, disabled: false },
				{ id: 'expertContract', label: 'Gutachten-Auftrag', isChecked: false, disabled: false },
				{ id: 'rentalCarContract', label: 'Mietwagen-Vertrag', isChecked: false, disabled: false },
				{ id: 'paymentOrder', label: 'Zahlungsanweisung', isChecked: false, disabled: false },
				{ id: 'paymentAssignment', label: 'Abtretung', isChecked: false, disabled: false },
			],
			autoClicked: { id: '', value: false },
			availableRentalCars: true,
		};
	},
	computed: {
		evaluateDisabled() {
			const checkedDocs = this.documents.filter(document => document.isChecked === true);
			return checkedDocs.length < 1;
		},
	},
	methods: {
		checkShowTooltip(document) {
			if (document.id === 'rentalCarContract') {
				if (!this.availableRentalCars) {
					return true;
				} else if (this.$store.getters.getOnboardingData.rentalCarCosts === false) {
					return true;
				}
			} else if (
				document.id === 'paymentAssignment' &&
				this.process.opposite_insurance_state == null &&
				this.process.processType === 'comprehensive'
			) {
				return true;
			}
			return false;
		},
		getTooltipString(document) {
			if (document.id === 'paymentAssignment') {
				return this.$t('fill_in_insurance_data');
			} else {
				if (this.$store.getters.getOnboardingData.rentalCarCosts === false) {
					return this.$t('enter_rental_car_prices');
				} else {
					return this.$t('no_rental_cars_available');
				}
			}
		},
		checkValidity(value) {
			if (value.id === 'lawyerAuthority') {
				if (this.documents.find(document => document.id === 'lawyerAuthority').isChecked) {
					this.documents.find(document => document.id === 'paymentOrder').isChecked = true;
					this.documents.find(document => document.id === 'paymentAssignment').isChecked = false;
				} else {
					this.documents.find(document => document.id === 'paymentOrder').isChecked = false;
				}
			} else if (value.id === 'paymentOrder') {
				if (value.isChecked && this.documents.find(document => document.id === 'paymentAssignment').isChecked) {
					this.documents.find(document => document.id === 'paymentOrder').isChecked = true;
					this.documents.find(document => document.id === 'lawyerAuthority').isChecked = true;
					this.documents.find(document => document.id === 'paymentAssignment').isChecked = false;
				} else if (value.isChecked) {
					this.documents.find(document => document.id === 'paymentOrder').isChecked = true;
					this.documents.find(document => document.id === 'lawyerAuthority').isChecked = true;
				} else {
					this.$swal({
						title: this.$t('sure').toString(),
						text: this.$t('unselect_payment_order').toString(),
						icon: 'warning',
						cancelButtonText: this.$t('general.no').toString(),
						showCancelButton: true,
						confirmButtonText: this.$t('general.yes').toString(),
					}).then(result => {
						if (!result.value) {
							this.documents.find(document => document.id === 'paymentOrder').isChecked = true;
						}
					});
				}
			} else if (value.id === 'paymentAssignment') {
				if (value.isChecked && this.documents.find(document => document.id === 'paymentOrder').isChecked) {
					this.documents.find(document => document.id === 'paymentOrder').isChecked = false;
					this.documents.find(document => document.id === 'paymentAssignment').isChecked = true;
				}
			}
			this.checkAlreadyGenerated(value);
		},
		checkAlreadyGenerated(document) {
			if (document.isChecked) {
				let showOverwriteWarning = false;
				const documentName = document.id;
				switch (documentName) {
					case 'repairContract':
						showOverwriteWarning =
							this.$store.getters.getDocumentsRepairShop.find(document => document.type === 'reparatur-auftrag' && document.uuid != null) !==
							undefined;
						break;
					case 'lawyerAuthority':
						showOverwriteWarning =
							this.$store.getters.getDocumentsLawyer.find(document => document.type === 'vollmacht-anwalt' && document.uuid != null) !== undefined;
						break;
					case 'expertContract':
						showOverwriteWarning =
							this.$store.getters.getDocumentsDamageAssessor.find(document => document.type === 'damageassessor' && document.uuid != null) !==
							undefined;
						break;
					case 'rentalCarContract':
						showOverwriteWarning =
							this.$store.getters.getDocumentsRepairShop.find(document => document.type === 'rentalcar_contract' && document.uuid != null) !==
							undefined;
						break;
					case 'paymentOrder':
						showOverwriteWarning =
							this.$store.getters.getDocumentsLawyer.find(document => document.type === 'lawyer_payment_order' && document.uuid != null) !==
							undefined;
						break;
					case 'paymentAssignment':
						showOverwriteWarning =
							this.$store.getters.getDocumentsRepairShop.find(document => document.type === 'payment_order_assignment' && document.uuid != null) !==
							undefined;
						break;
					case 'nebenleistungen':
						showOverwriteWarning =
							this.$store.getters.getDocumentsRepairShop.find(document => document.type === 'nebenleistungen' && document.uuid != null) !== undefined;
				}

				if (showOverwriteWarning) {
					let label = this.$t('generate_document_overwrite', { type: document.label });
					if (
						documentName === 'lawyerAuthority' &&
						this.$store.getters.getDocumentsLawyer.find(document => document.type === 'lawyer_payment_order' && document.uuid != null) !== undefined
					) {
						label = this.$t('multiple_document_overwrite', { type: document.label, type1: 'Zahlungsanweisung' });
					}
					if (
						documentName === 'paymentOrder' &&
						this.$store.getters.getDocumentsLawyer.find(document => document.type === 'vollmacht-anwalt' && document.uuid != null) !== undefined
					) {
						label = this.$t('multiple_document_overwrite', { type: document.label, type1: 'Rechtsanwalt-Vollmacht' });
					}

					this.$swal({
						title: this.$t('sure').toString(),
						text: label,
						icon: 'warning',
						cancelButtonText: this.$t('general.no').toString(),
						showCancelButton: true,
						confirmButtonText: this.$t('general.yes').toString(),
					}).then(result => {
						if (!result.value) {
							this.documents.find(document => document.id === documentName).isChecked = false;
							if (document.id === 'lawyerAuthority') {
								this.documents.find(document => document.id === 'paymentOrder').isChecked = false;
								this.documents.find(document => document.id === 'paymentAssignment').isChecked = false;
							}
							if (document.id === 'paymentOrder') {
								this.documents.find(document => document.id === 'lawyerAuthority').isChecked = false;
							}
						}
					});
				}
			}
		},
		createDocuments() {
			const checkedDocs = this.documents.filter(document => document.isChecked === true);
			if (checkedDocs.length < 1) {
				return this.$swal(this.$t('general.error').toString(), this.$t('select_least_one_document_type').toString(), 'error');
			}
			const selectedDocuments = {
				expertContract: false,
				lawyerAuthority: false,
				paymentOrder: false,
				repairContract: false,
				rentalCarContract: false,
				paymentAssignment: false,
				nebenleistungen: false,
			};
			this.documents.forEach(document => {
				if (document.isChecked) {
					switch (document.id) {
						case 'expertContract':
							selectedDocuments.expertContract = true;
							break;
						case 'lawyerAuthority':
							selectedDocuments.lawyerAuthority = true;
							break;
						case 'paymentOrder':
							selectedDocuments.paymentOrder = true;
							break;
						case 'repairContract':
							selectedDocuments.repairContract = true;
							break;
						case 'rentalCarContract':
							selectedDocuments.rentalCarContract = true;
							break;
						case 'paymentAssignment':
							selectedDocuments.paymentAssignment = true;
							break;
						case 'nebenleistungen':
							selectedDocuments.nebenleistungen = true;
					}
				}
			});
			this.$router.push({
				name: 'management.process.create-documents',
				query: { customer_id: this.process.customer.id, vehicle_id: this.process.vehicle.id },
				params: { backlink: this.$route, workflowSelection: selectedDocuments },
			});
		},
	},
	created() {
		if (this.$store.getters.getDamageCase.process_type === 'comprehensive') {
			this.documents = [
				{ id: 'repairContract', label: 'Reparatur-Auftrag', isChecked: false, disabled: false },
				{ id: 'paymentAssignment', label: 'Abtretung', isChecked: false, disabled: false },
				{ id: 'nebenleistungen', label: 'Nebenleistungen', isChecked: false, disabled: false },
			];
			if (this.process.opposite_insurance_state == null) {
				this.documents.find(document => document.id === 'paymentAssignment').disabled = true;
			}
		} else if (this.$store.getters.getDamageCase.process_type === 'order_documentation') {
			this.documents = [{ id: 'repairContract', label: 'Reparatur-Auftrag', isChecked: false, disabled: false }];
		} else {
			if (this.$store.getters.getDamageCase.damageAssessor != null && !this.$store.getters.getDamageCase.damageAssessor.system_assessor) {
				this.documents.splice(
					this.documents.findIndex(v => v.id === 'expertContract'),
					1,
				);
			}
			new RentalCarsRepository().getOnlyFree(this.$store.getters.getDamageCase.id).then(result => {
				if (result.data.data.length > 0) {
					this.availableRentalCars = true;
					if (this.$store.getters.getOnboardingData.rentalCarCosts === false) {
						this.documents.find(document => document.id === 'rentalCarContract').disabled = true;
						this.documents.find(document => document.id === 'rentalCarContract').isChecked = false;
					}
				} else {
					this.availableRentalCars = false;
					this.documents.find(document => document.id === 'rentalCarContract').disabled = true;
					this.documents.find(document => document.id === 'rentalCarContract').isChecked = false;
				}
			});
		}
	},
};
</script>

<style scoped></style>
